<template>
    <div
        class="WTextarea"
        :class="{ error }"
    >
        <textarea
            :id="id"
            ref="textarea"
            :value="value"
            :name="name"
            :placeholder="placeholder"
            :readonly="readonly"
            :rows="rows"
            :class="{ filled, focused }"
            v-on="inputListeners"
        />
        <Transition
            name="fade"
            :duration="500"
        >
            <WText
                v-if="error"
                class="Error"
                typo="span"
                size="10"
                color="red"
            >
                {{ error }}
            </WText>
        </Transition>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { merge } from 'lodash'
import { generateIdMixin } from '@/mixins'

export default {
    name: 'WTextarea',
    mixins: [generateIdMixin],
    props: {
        error: VueTypes.string.def(''),
        name: VueTypes.string.isRequired,
        placeholder: VueTypes.string.def(''),
        readonly: VueTypes.bool.def(false),
        resizable: VueTypes.bool.def(false),
        rows: VueTypes.number.def(3),
        value: VueTypes.oneOfType([String, Number]).isRequired,
    },
    data () {
        return {
            focused: false,
        }
    },
    computed: {
        inputListeners () {
            return merge({}, this.$listeners, {
                input: (event) => {
                    if (this.resizable) this.resizeTextarea(event)
                    this.$emit('input', event.target.value, this.id)
                },
                focus: (event) => {
                    this.$emit('onFocus', event.target.value, this.id)
                    this.activeFocus()
                },
                blur: (event) => {
                    this.$emit('onBlur', event.target.value, this.id)
                    this.deactiveFocus()
                },
            })
        },
        filled () {
            return (this.value || '').length > 0
        },
    },
    mounted () {
        if (this.resizable) {
            this.$nextTick(() => this.setHeight(this.$refs.textarea))
        }
    },
    methods: {
        resizeTextarea (event) {
            this.$refs.textarea.style.height = 'auto'
            this.setHeight(event.target)
        },
        setHeight ({ scrollHeight }) {
            this.$refs.textarea.setAttribute('style', `height: ${scrollHeight}px;overflow-y: hidden;`)
        },
        activeFocus () {
            this.focused = true
        },
        deactiveFocus () {
            this.focused = false
        },
    },
}
</script>

<style scoped lang="scss">
@import "@/theme/mixins/_global.scss";

textarea {
    width: 100%;
    min-height: $form-height;
    padding: $form-padding;
    resize: none;
    border: $form-border;
    border-radius: $border-radius;
    background: transparent;
    color: $form-color;
    font-size: $form-font-size;
    font-weight: $form-font-weight;
    box-sizing: border-box;
    transition: border-color 0.5s ease-in-out;
    @include placeholder {
        color: $form-placeholder-color !important;
    }
    &:focus {
        border-color: $form-border-color-active;
        outline: none;
    }
    &[readonly] {
        border-bottom: $form-border;
        cursor: not-allowed;
    }
}

.WTextarea {
    position: relative;
    &.error {
        textarea {
            opacity: .5;
        }
    }
}

.Error {
    position: absolute;
    top: $form-height + 5px;
    left: 5px;
}
</style>
